<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file InfoButton.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  InfoButton.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <BaseButtonRound
            :btn_type="active?'btn-default':'btn-info'"
            @click="click"
    >
        <template slot="content">
            <i class="material-icons">info</i>
        </template>
    </BaseButtonRound>
</template>

<script>
    export default {
        name: "InfoButton",
        props: {
            active: {
                type: Boolean,
                default: false
            },
        },
        methods:{
            click(){
                this.$emit('click')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/buttons/InfoButton.vue